import { render, staticRenderFns } from "./AddSkillModal.vue?vue&type=template&id=32d8d79d&scoped=true&"
import script from "./AddSkillModal.vue?vue&type=script&lang=ts&"
export * from "./AddSkillModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddSkillModal.vue?vue&type=style&index=0&id=32d8d79d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8d79d",
  null
  
)

export default component.exports